import { render } from "./modal-item.vue?vue&type=template&id=95efd72a&ts=true"
import script from "./modal-item.vue?vue&type=script&lang=ts"
export * from "./modal-item.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\solutions\\Snappii Server Side and Web Site\\_projects\\wincode\\Store2Phone_Builder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__